import { kinks } from '@turf/turf';
import { toTurfPolygon } from 'js/algorithms/geometry/googleToTurf';

export default function isPolygonSelfIntersecting(polygonPath) {
  let poly = toTurfPolygon(polygonPath);
  let intersections = kinks(poly);
  return intersections.features.length > 0;
}
